import { ContractChangeStatusEnum } from 'gql/graphql';

export const useGetDialogWarningText = ({
    initialStatus,
    nextStatus,
}: {
    initialStatus: ContractChangeStatusEnum | any;
    nextStatus: ContractChangeStatusEnum | any;
}) => {
    const changedFromFormation = initialStatus === ContractChangeStatusEnum.Formation;
    const changedFromApproving = initialStatus === ContractChangeStatusEnum.Approving;

    const changedToApproving = nextStatus === ContractChangeStatusEnum.Approving;
    const changedToApproved = nextStatus === ContractChangeStatusEnum.Approved;

    if (changedFromFormation && changedToApproving) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «На согласовании» дальнейшее редактирование ДС будет недоступно.
                </div>
                <div>Вы уверены, что хотите изменить статус?</div>
            </>
        );
    }

    if (changedFromApproving && changedToApproved) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «Согласован» дальнейшее редактирование ДС будет недоступно.
                </div>
                <div>Вы уверены, что хотите изменить статус?</div>
            </>
        );
    }

    return <div> Вы уверены, что хотите изменить статус?</div>;
};
